
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CheckBox extends Vue {
   
   @Prop({required: true})
    text!: string;

    @Prop({required: true})
    check!: string;

    @Prop({default: 0})
    shiftmark!: number;

    @Prop({default: 0})
    shift!: number;

    public getCheck(){
        if(this.check) return "&#10003"
        return ""
    }
    public getShift(){
        const temp = 30+Number(this.shift)
        if(this.shift !=0) return  temp+ 'px'
        return '30px'
    }
}
